import { t } from 'i18next';
import React from 'react';

import styles from '../Item.styles';

interface ActivityTitleProps {
  translatedTitle?: string | null;
}

const ActivityTitle: React.FC<ActivityTitleProps> = ({ translatedTitle }) => (
  <>
    {translatedTitle ? (
      <div style={styles.title}>{translatedTitle}</div>
    ) : (
      <div style={styles.titlePlaceholder}>{t('activities:list.activity_title_placeholder')}</div>
    )}
  </>
);

export default ActivityTitle;
